import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';
import { TagVariant } from '@amzn/storm-ui';

import { GTM_STATUS_ENUM_TO_LABEL_MAP } from '../../../../CreateBooking/constants/DetailedBookingConstants';
import { StyledTag, GtmBadgeColor } from './GtmStatusCellRenderer.styles';

const COLOR_TO_VARIANT: Record<GtmBadgeColor, TagVariant> = {
  green: 'success',
  blue: 'info',
  red: 'error',
};

/**
 * Renders the GTM status as a colored Tag (Storm UI) with custom text color.
 * Ready = success (green), Sent for GTM Review = info (blue), Not Ready = error (red).
 * Unknown / empty values render as a plain dash.
 */
const GtmStatusCellRenderer: React.FC<ICellRendererParams> = ({ value }) => {
  const { t } = useTranslation();

  const meta = GTM_STATUS_ENUM_TO_LABEL_MAP.find((item) => item.value === value);

  if (!meta) return <span>-</span>;

  const color = meta.color as GtmBadgeColor;

  return <StyledTag $color={color} label={t(meta.label)} variant={COLOR_TO_VARIANT[color]} />;
};

export default GtmStatusCellRenderer;
